import { useEntity } from '@backstage/plugin-catalog-react';
import { CopilotChatInterface } from './CopilotChatInterface';


export const isCopilotAvailable = (entity: any) => {
  // Available for any entity — the backend config determines if Copilot is enabled
  return Boolean(entity);
};

export const CopilotContent = () => {
  const { entity } = useEntity();
  const entityRef = entity
    ? `${entity.kind.toLowerCase()}:${entity.metadata.namespace ?? 'default'}/${entity.metadata.name}`
    : undefined;
  const entityLabel = entity ? `${entity.kind}/${entity.metadata.name}` : undefined;
  return <CopilotChatInterface entityRef={entityRef} entityLabel={entityLabel} />;
};

